// src/pages/legal/Mentions.js
import React from 'react';

const Mentions = () => {
  return (
    <div className="container-custom py-12">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Mentions légales</h1>
        <p className="text-gray-500 mb-8">Dernière mise à jour : 15 Juin 2024</p>
        
        <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
          <section>
            <h2 className="text-xl font-bold mb-3">Éditeur du site</h2>
            <p className="text-gray-600">
              AquaExpress SAS<br />
              Capital social : 10 000 €<br />
              RCS Mulhouse : 123 456 789<br />
              Siège social : 1 Rue de la Livraison, 68100 Mulhouse<br />
              Téléphone : 01 23 45 67 89<br />
              Email : contact@aquaexpress.fr
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Directeur de publication</h2>
            <p className="text-gray-600">Jean Dupont, Président d'AquaExpress SAS</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Hébergement</h2>
            <p className="text-gray-600">
              Vercel Inc.<br />
              340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis<br />
              Téléphone : +1 555-123-4567
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Protection des données</h2>
            <p className="text-gray-600">Conformément à la loi n° 78-17 du 6 janvier 1978 modifiée (informatique et libertés) et au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant. Pour exercer ce droit, contactez-nous à dpo@aquaexpress.fr.</p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-3">Propriété intellectuelle</h2>
            <p className="text-gray-600">L'ensemble du contenu du site (textes, images, logos) est la propriété exclusive d'AquaExpress SAS. Toute reproduction est interdite sans autorisation préalable.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Mentions;